// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.epr-selector-ratings {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}
.epr-selector-ratings h5 {
  color: #0A4064;
  margin-bottom: 0px;
}
.epr-selector-ratings .rating-select-dropdown {
  margin-left: 0.5rem;
  padding: 0.25rem 0.5rem;
  font-size: 1.15rem;
  font-weight: 500;
  border: 2px solid #0A4064;
  border-radius: 8px;
  background-color: white;
  color: #0A4064;
  cursor: pointer;
}
.epr-selector-ratings .rating-select-dropdown:hover {
  background-color: #EDF0F1;
}
.epr-selector-ratings .epr-options {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.epr-selector-ratings .button-outline {
  background-color: white;
  color: #0A4064;
  border: 2px solid #0A4064;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  font-size: 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  text-align: center;
}
.epr-selector-ratings .button-outline.active {
  background-color: #0A4064;
  color: white;
}
.epr-selector-ratings .button-outline:hover {
  background-color: #0A4064;
  color: white;
  opacity: 0.9;
}
.epr-selector-ratings .button-outline:disabled {
  background-color: #D1D3D4;
  border-color: #A7A9AC;
  color: #808080;
  cursor: not-allowed;
}

.group-select-section {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}
.group-select-section h5 {
  color: #0A4064;
  margin-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/BatchStudentRatings.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AANA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AASJ;AAPI;EACE,cDDI;ECEJ,kBAAA;AASN;AANI;EACE,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cDbI;ECcJ,eAAA;AAQN;AANM;EACE,yBAAA;AAQR;AAJI;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAMN;AAHI;EACE,uBAAA;EACA,cD7BI;EC8BJ,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAKN;AAHM;EACE,yBDvCE;ECwCF,YAAA;AAKR;AAFM;EACE,yBD5CE;EC6CF,YAAA;EACA,YAAA;AAIR;AADM;EACE,yBDhCA;ECiCA,qBDhCA;ECiCA,cDhCA;ECiCA,mBAAA;AAGR;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AACI;EACE,cDhEI;ECiEJ,kBAAA;AACN","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n\n.epr-selector-ratings {\n    display: flex;\n    align-items: center;\n    margin-bottom: 2rem;\n\n    h5 {\n      color: $dk-blue;\n      margin-bottom: 0px;\n    }\n\n    .rating-select-dropdown {\n      margin-left: 0.5rem;\n      padding: 0.25rem 0.5rem;\n      font-size: 1.15rem;\n      font-weight: 500;\n      border: 2px solid $dk-blue;\n      border-radius: 8px;\n      background-color: white;\n      color: $dk-blue;\n      cursor: pointer;\n\n      &:hover {\n        background-color: $grey0;\n      }\n    }\n\n    .epr-options {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 1rem;\n    }\n\n    .button-outline {\n      background-color: white;\n      color: $dk-blue;\n      border: 2px solid $dk-blue;\n      padding: 0.75rem 1.5rem;\n      font-weight: 600;\n      font-size: 1rem;\n      border-radius: 8px;\n      transition: all 0.2s ease;\n      text-align: center;\n\n      &.active {\n        background-color: $dk-blue;\n        color: white;\n      }\n\n      &:hover {\n        background-color: $dk-blue;\n        color: white;\n        opacity: .9;\n      }\n\n      &:disabled {\n        background-color: $grey1;\n        border-color: $grey2;\n        color: $grey3;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  .group-select-section {\n    display: flex;\n    align-items: center;\n    margin-bottom: 2rem;\n\n    h5 {\n      color: $dk-blue;\n      margin-bottom: 0px;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
